import * as tslib_1 from "tslib";
import { OnInit, } from '@angular/core';
import { FormBuilder, } from '@angular/forms';
import { UiModalComponent } from '@components';
import { LicenseEnvironment, LicenseFormControl, } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
var ActivateOnlineModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ActivateOnlineModalComponent, _super);
    function ActivateOnlineModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading$ = new BehaviorSubject(false);
        _this.LicenseFormControl = LicenseFormControl;
        _this._translateService = _this._injector.get(TranslateService);
        return _this;
    }
    ActivateOnlineModalComponent.prototype.ngOnInit = function () {
        var _a;
        this.context.data = {
            installationId: this.context.data.installationId,
            licenseKey: '',
            environment: LicenseEnvironment.Production,
            offline: this.context.data.offline,
        };
        this.formGroup = this._injector.get(FormBuilder).group((_a = {},
            _a[LicenseFormControl.installationId] = [
                this.context.data.installationId,
            ],
            _a[LicenseFormControl.licenseKey] = [
                this.context.data.licenseKey,
            ],
            _a[LicenseFormControl.environment] = [
                this.context.data.environment,
            ],
            _a));
    };
    ActivateOnlineModalComponent.prototype.clipboardCopied = function () {
        this._snack.success(this._translateService.instant('global_message_copied_clipboard'));
    };
    ActivateOnlineModalComponent.prototype.openOfflineModal = function () {
        this._dialogRef.close({
            type: 5 /* Failed */,
        });
    };
    Object.defineProperty(ActivateOnlineModalComponent.prototype, "isSubmitDisabled", {
        get: function () {
            return this.loading$.value ||
                !this.formGroup ||
                !this.formGroup.dirty ||
                this.formGroup.invalid;
        },
        enumerable: true,
        configurable: true
    });
    ActivateOnlineModalComponent.prototype.onSubmit = function () {
        if (this.isSubmitDisabled) {
            return;
        }
        var licenseKey = this.formGroup.get(LicenseFormControl.licenseKey).value;
        var environment = this.formGroup.get(LicenseFormControl.environment).value;
        this._dialogRef.close({
            type: 1 /* Add */,
            data: {
                installationId: this.context.data.installationId,
                licenseKey: licenseKey,
                environment: environment,
            },
        });
    };
    return ActivateOnlineModalComponent;
}(UiModalComponent));
export { ActivateOnlineModalComponent };
